<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item   prop="name" label="奖品名称">
                        <el-input v-model="form.name" maxlength="80" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="iconUrl" label="奖品图片">
                        <el-select v-model="form.iconUrl" clearable placeholder="请选择" style="width:200px;" @change="imageChange">
                            <el-option
                                v-for="item in images"
                                :key="item.url"
                                :label="item.text"
                                :value="item.url">
                                <span>{{item.text}}</span>
                                <img :src="item.url" style="height:32px;float: right"> 
                            </el-option>
                        </el-select>
                        <div v-if="form.iconUrl!=null && form.iconUrl!=''">
                            图片预览：
                            <div><img :src="form.iconUrl" alt="" style="width: 50px;height: 50px;"></div>
                        </div>
                    </el-form-item> 
                    
                    <el-form-item   prop="exchangeScore" label="兑换积分">
                        <el-input v-model="form.exchangeScore" maxlength="10" type="number" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="2" type="number" style="width:200px;"></el-input>
                    </el-form-item>
                  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    name:"",
                    iconUrl:"",
                    exchangeScore:"",
                    orderNum:"",
                },
                images:[],
                rules: {
                    name: [
                        { required: true, message: '请输入奖品名称', trigger: 'blur' }
                    ],
                    iconUrl: [
                        { required: true, message: '请输入奖品图片', trigger: 'blur' }
                    ],
                    exchangeScore: [
                        { required: true, message: '请输入兑换积分', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                },
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.images=[];
                this.getImages();

                this.form.id=data.id;
                this.form.name=data.name;
                this.form.iconUrl=data.iconUrl;
                this.form.exchangeScore=data.exchangeScore;
                this.form.orderNum=data.orderNum;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getImages(){
                let url = this.classPrizeImageUrl;
                let data = {
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.images=res.data;
                    }
                },(err) => {
                    console.log(err);
                })
            },
            // 保存
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        let url= this.classPrizeUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            iconUrl:this.form.iconUrl,
                            exchangeScore:this.form.exchangeScore,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            imageChange(){
                console.log('',this.form.iconUrl);

            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/shop/prize/update.vue